import React from 'react';
import ROUTE_PATH from 'routes/config';
import CheckableTypeStipulation from 'components/CheckableTypeStipulation';
import TextTypeStipulation from 'components/TextTypeStipulation';

const DataInterlockStipulation = ({ stipulationList, setStipulationList }) => {
  //약관 전체보기
  const onClickViewBtn = dataProviderMallStipulationMappingSeq => {
    if (!dataProviderMallStipulationMappingSeq) {
      return;
    }
    window._stipulationData = stipulationList?.find(
      item =>
        item.dataProviderMallStipulationMappingSeq ===
        dataProviderMallStipulationMappingSeq
    );
    window.open(
      `${ROUTE_PATH.policyDefault}/${dataProviderMallStipulationMappingSeq}`,
      '_blank'
    );
  };

  return (
    <div>
      {stipulationList[0]?.stipulationTypeCd === 'STC100' ? (
        <CheckableTypeStipulation
          stipulationList={stipulationList}
          setStipulationList={setStipulationList}
          onClickViewBtn={onClickViewBtn}
          stipulationSeq="dataProviderMallStipulationMappingSeq"
        />
      ) : (
        <TextTypeStipulation
          stipulationList={stipulationList}
          setStipulationList={setStipulationList}
        />
      )}
    </div>
  );
};

export default DataInterlockStipulation;
